module.exports = __webpack_public_path__ + "static/media/XLM.1d4889df.svg";